export enum LessonCreationStatus {
  IN_PROGRESS = 'PRO',
  FINISH = 'FIN',
}
